// DB module format
export interface EncryptionModule {
  enabled: boolean;
  mode: EncryptionMode;
  encryptPolicy: {
    tpm: {
      shouldAskForPassword: boolean;
    };
  };
  exclusions: {
    enabled: boolean;
    items: EncryptionExclusionItem[];
  };
}

export interface EncryptionExclusionItem {
  type: EncryptionExclusionItemType;
  entity: string;
}

// enums for ui settings
export enum EncryptionMode {
  DECRYPT = 0,
  ENCRYPT = 1,
}
export enum EncryptionExclusionItemType {
  MOUNT_POINT = 1,
  VOLUME_ID = 2,
  PARTITION_NAME = 3,
}
